// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__1WlxV","OrderButton":"BuildControls_OrderButton__39nWC","enable":"BuildControls_enable__1fMxy"};